var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4233 2.50781V3.41578C17.105 4.00027 19.9233 7.18984 19.9233 11.0391V12.7352C19.9233 15.0406 20.7105 17.2801 22.1476 19.0828L22.9042 20.0273C23.1987 20.393 23.2546 20.8957 23.0515 21.3172C22.8483 21.7387 22.4218 22.0078 21.9546 22.0078H1.6421C1.17339 22.0078 0.746572 21.7387 0.54365 21.3172C0.340677 20.8957 0.397755 20.393 0.690459 20.0273L1.44761 19.0828C2.88827 17.2801 3.67335 15.0406 3.67335 12.7352V11.0391C3.67335 7.18984 6.49171 4.00027 10.1733 3.41578V2.50781C10.1733 1.61051 10.8995 0.882812 11.7983 0.882812C12.6972 0.882812 13.4233 1.61051 13.4233 2.50781ZM11.3921 5.75781C8.47725 5.75781 6.11085 8.12422 6.11085 11.0391V12.7352C6.11085 15.1676 5.40601 17.5391 4.09534 19.5703H19.5019C18.1917 17.5391 17.4858 15.1676 17.4858 12.7352V11.0391C17.4858 8.12422 15.1194 5.75781 12.2046 5.75781H11.3921ZM15.0483 23.6328C15.0483 24.4504 14.7081 25.3238 14.0987 25.9332C13.4894 26.5426 12.6159 26.8828 11.7983 26.8828C10.9351 26.8828 10.1073 26.5426 9.49796 25.9332C8.88858 25.3238 8.54835 24.4504 8.54835 23.6328H15.0483Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.17f99d621a53c6de267a5f64d8783e65.svg";
export { ForwardRef as ReactComponent };